module.exports = __webpack_public_path__ + "static/media/solo47.b352d098.JPG";